<template>
    <div>
        <!-- <el-row :gutter="30">
            <el-col :xs="24" :xl="16">
                <el-form-item :prop="`sessions[${index}].realName`">
                    <el-radio-group v-model="formData.realName" size="medium">
                        <el-radio :label="1">开启 <small class="color-warning">每个观演人需要绑定实名证件（身份证、港澳居民来往内地通行证、台湾居民来往大陆通行证、护照、外国人永久居留身份证、港澳台居民居住证），即一证一票</small></el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
        </el-row> -->

        <template>
            <el-row :gutter="30" >
                <el-col :xs="24" :xl="16">
                    <!-- <el-card v-show="formData.realName == 1" shadow="never">
                       <el-form-item :prop="`sessions[${index}].buyType`" label="证件绑定时机:" :rules="[{required: true, message: `请选择场次${index+1}的证件绑定时机`}]">
                            <el-radio-group v-model="formData.buyType" size="medium">
                                <el-radio :label="2">下单时绑定</el-radio>
                                <el-radio :label="3" :disabled="formData.ticketType == 2 || formData.ticketType == 4">下单后票夹中绑定</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        
                    </el-card> -->
					<el-form-item :prop="`sessions[${index}].commonPerformerDocumentType`"  :rules="[{required: true, message: `请选择场次${index+1}的证件绑定类型限制`}]">
					    <el-checkbox-group v-model="formData.commonPerformerDocumentType" size="medium">
					        <el-checkbox label="1">身份证</el-checkbox>
					        <el-checkbox label="2">港澳居民来往内地通行证</el-checkbox>
					        <el-checkbox label="3">台湾居民来往大陆通行证</el-checkbox>
					        <el-checkbox label="4">护照</el-checkbox>
					        <el-checkbox label="5">外国人永久居留身份证</el-checkbox>
					        <el-checkbox label="6">港澳台居民居住证</el-checkbox>
					    </el-checkbox-group>
					</el-form-item>
                </el-col>
            </el-row>
        </template>

    </div>
</template>

<script>
export default {
    props:{
        formData: {
            type: Object,
            default: null
        },
        index:{
            type:Number,
            default: 0
        }
    },
    watch:{
        'formData.ticketType'(v){
            if( v == 2 || v == 4 ){
                this.formData.buyType = 2
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.el-card{
    margin-bottom: 20px;
}
</style>